import React from 'react'
import { Table } from 'antd'
import { TableRowEditButton } from '../../components/AppButton'
import FormattedDate from '../../components/FormattedDate'
import FormattedBool from '../../components/FormattedBool'

class ItemListTable extends React.Component {
  render() {
    const columns = [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        fixed: 'left',
        width: 10,
        sorter: true,
      }, {
        title: 'Sorting Index',
        dataIndex: 'sorting_index',
        sorter: true,
        width: 10,
        key: 'sorting_index',
      }, {
        title: 'Enable?',
        dataIndex: 'disable',
        key: 'disable',
        sorter: true,
        width: 10,
        render: bool => <FormattedBool rev bool={bool} />,
      }, {
        title: 'Display at listing?',
        dataIndex: 'display_at_listing',
        key: 'display_at_listing',
        sorter: true,
        width: 10,
        render: bool => <FormattedBool rev bool={bool} />,
      }, {
        title: 'Name: en-US',
        dataIndex: 'name_en-US',
        key: 'name_en-US',
      }, {
        title: 'Created At',
        dataIndex: 'created_at',
        key: 'created_at',
        sorter: true,
        render: text => <FormattedDate text={text} />,
      }, {
        title: 'Action',
        key: 'action',
        fixed: 'right',
        width: 100,
        render: (text, record) => (
          <span>
            <TableRowEditButton to={`${this.props.editPath}/${record.id}`} />
          </span>
        ),
      },
    ]
    return (
      <Table
        rowKey={record => `item-row-${record.id}`}
        columns={columns}
        size='small'
        scroll={{ x: 1300 }}
        {...this.props}
      />
    )
  }
}

export default ItemListTable
